import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/admin',
    component: Layout,
    meta: { title: '管理员管理', icon: 'el-icon-user-solid' },
    children: [
      {
        path: 'list',
        name: 'AdminList',
        component: () => import('@/views/admin/index.vue'),
        meta: { title: '管理员列表' }
      }
    ]
  },
  {
    path: '/school',
    component: Layout,
    meta: { title: '学校管理', icon: 'el-icon-school', roles: ['super_admin'] },
    children: [
      {
        path: 'list',
        name: 'SchoolList',
        component: () => import('@/views/school/index.vue'),
        meta: { title: '学校列表', roles: ['super_admin'] }
      }
    ]
  },
  {
    path: '/teacher',
    component: Layout,
    meta: { title: '老师管理', icon: 'el-icon-user' },
    children: [
      {
        path: 'list',
        name: 'TeacherList',
        component: () => import('@/views/teacher/index.vue'),
        meta: { title: '老师列表' }
      }
    ]
  },
  {
    path: '/class',
    component: Layout,
    meta: { title: '班级管理', icon: 'el-icon-s-custom' },
    children: [
      {
        path: 'list',
        name: 'ClassList',
        component: () => import('@/views/class/index.vue'),
        meta: { title: '班级列表' }
      }
    ]
  },
  {
    path: '/class-teacher',
    component: Layout,
    meta: { title: '班级教师', icon: 'el-icon-connection' },
    children: [
      {
        path: 'list',
        name: 'ClassTeacherList',
        component: () => import('@/views/class-teacher/index.vue'),
        meta: { title: '班级教师关联' }
      }
    ]
  },
  {
    path: '/student',
    component: Layout,
    meta: { title: '学生管理', icon: 'el-icon-user' },
    children: [
      {
        path: 'list',
        name: 'StudentList',
        component: () => import('@/views/student/index.vue'),
        meta: { title: '学生列表' }
      }
    ]
  },
  {
    path: '/course',
    component: Layout,
    meta: { title: '课程管理', icon: 'el-icon-notebook-1' },
    children: [
      {
        path: 'list',
        name: 'CourseList',
        component: () => import('@/views/course/index.vue'),
        meta: { title: '课程列表' }
      },
      {
        path: 'knowledge-point',
        name: 'KnowledgePointList',
        component: () => import('@/views/knowledge-point/index.vue'),
        meta: { title: '知识点管理' }
      }
    ]
  },
  {
    path: '/schedule',
    component: Layout,
    meta: { title: '课程表管理', icon: 'el-icon-date' },
    children: [
      {
        path: 'list',
        name: 'ScheduleList',
        component: () => import('@/views/schedule/index.vue'),
        meta: { title: '课程表列表' }
      },
      {
        path: 'change',
        name: 'ScheduleChange',
        component: () => import('@/views/schedule-change/index.vue'),
        meta: { title: '变更历史' }
      }
    ]
  },
  {
    path: '/questionnaire',
    component: Layout,
    meta: { title: '问卷管理', icon: 'el-icon-document' },
    children: [
      {
        path: 'list',
        name: 'QuestionnaireList',
        component: () => import('@/views/questionnaire/index.vue'),
        meta: { title: '问卷列表' }
      },
      {
        path: 'detail/:id',
        name: 'QuestionnaireDetail',
        component: () => import('@/views/questionnaire/detail.vue'),
        meta: { title: '问卷详情' }
      },
      {
        path: 'assign',
        name: 'QuestionnaireAssign',
        component: () => import('@/views/questionnaire/assign.vue'),
        meta: { title: '问卷分配' }
      },
      {
        path: 'response/:assignmentId',
        name: 'QuestionnaireResponseList',
        component: () => import('@/views/questionnaire/response.vue'),
        meta: { title: '学生答题列表' }
      }
    ]
  },
  {
    path: '/homework',
    component: Layout,
    meta: { title: '作业管理', icon: 'el-icon-edit-outline' },
    children: [
      {
        path: 'list',
        name: 'HomeworkList',
        component: () => import('@/views/homework/index.vue'),
        meta: { title: '作业列表' }
      }
    ]
  },
  {
    path: '/material',
    component: Layout,
    meta: { title: '资料管理', icon: 'el-icon-folder-opened' },
    children: [
      {
        path: 'list',
        name: 'MaterialList',
        component: () => import('@/views/material/index.vue'),
        meta: { title: '资料列表' }
      }
    ]
  },
  {
    path: '/task',
    component: Layout,
    meta: { title: '任务管理', icon: 'el-icon-s-check' },
    children: [
      {
        path: 'list',
        name: 'TaskList',
        component: () => import('@/views/task/index.vue'),
        meta: { title: '任务列表' }
      }
    ]
  },
  {
    path: '/attendance',
    component: Layout,
    meta: { title: '考勤管理', icon: 'el-icon-time' },
    children: [
      {
        path: 'list',
        name: 'AttendanceList',
        component: () => import('@/views/attendance/attendance_list.vue'),
        meta: { title: '考勤列表' }
      }
    ]
  },
  {
    path: '/evaluation',
    component: Layout,
    meta: { title: '测评分析', icon: 'el-icon-data-analysis' },
    children: [
      {
        path: 'list',
        name: 'EvaluationList',
        component: () => import('@/views/evaluation/index.vue'),
        meta: { title: '测评列表' }
      },
      {
        path: 'knowledge',
        name: 'EvaluationKnowledge',
        component: () => import('@/views/evaluation-knowledge/index.vue'),
        meta: { title: '知识点配置' }
      },
      {
        path: 'result',
        name: 'EvaluationResult',
        component: () => import('@/views/evaluation-result/index.vue'),
        meta: { title: '学生成绩' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫：判断 token
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
